import { createSpinner } from '@syncfusion/ej2-react-popups'
import Pages from './Pages.tsx'

import styles from './pageLayout.module.scss'
import { useEffect } from 'react'
import { useAppSelector } from '../redux/_reduxHooks.tsx'
import { useLocation } from 'react-router'
import { DynamicFooterFaceLift, DynamicHeaderFaceLift } from 'dynamicelement'

const PageLayout = () => {
  const topicLoading = useAppSelector((state) => state.web.customTopicLoading)
  const location = useLocation() // Get the current location

  const isNotFoundPage = location.pathname === '/'

  useEffect(() => {
    const html = document.getElementById('mainTarget')
    if (html instanceof HTMLElement) {
      createSpinner({
        target: html,
      })
    }
  }, [])

  return (
    <>
      <div className={`${styles.nwApp} ${topicLoading ? styles.loadingHeight : ''}`}>
        <>
          {!isNotFoundPage && (
            <div className={styles.nwAppHeader}>
              <DynamicHeaderFaceLift title="Videoaufzeichnung" />
            </div>
          )}
          <div className={styles.nwPage}>
            <div id={'mainTarget'} className={styles.nwMainContent}>
              <Pages />
            </div>
          </div>
          {!isNotFoundPage && <DynamicFooterFaceLift />}
        </>
      </div>
    </>
  )
}

export default PageLayout
